/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';

export const Loading = styled.div`
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--silver-base-97);
  z-index: 2;
`;
